var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import useMethods from './hooks/useMethods';
import useSetState from './hooks/useSetState';
import PhotoContext from './photo-context';
import PhotoSlider from './PhotoSlider';
var initialState = {
    images: [],
    visible: false,
    index: 0,
};
export default function PhotoProvider(_a) {
    var children = _a.children, onIndexChange = _a.onIndexChange, onVisibleChange = _a.onVisibleChange, restProps = __rest(_a, ["children", "onIndexChange", "onVisibleChange"]);
    var _b = __read(useSetState(initialState), 2), state = _b[0], updateState = _b[1];
    var uniqueIdRef = useRef(0);
    var images = state.images, visible = state.visible, index = state.index;
    var methods = useMethods({
        nextId: function () {
            return (uniqueIdRef.current += 1);
        },
        update: function (imageItem) {
            var currentIndex = images.findIndex(function (n) { return n.key === imageItem.key; });
            if (currentIndex > -1) {
                var nextImages = images.slice();
                nextImages.splice(currentIndex, 1, imageItem);
                updateState({
                    images: nextImages,
                });
                return;
            }
            updateState(function (prev) { return ({
                images: prev.images.concat(imageItem),
            }); });
        },
        remove: function (key) {
            updateState(function (prev) {
                var nextImages = prev.images.filter(function (item) { return item.key !== key; });
                var nextEndIndex = nextImages.length - 1;
                return {
                    images: nextImages,
                    index: Math.min(nextEndIndex, index),
                };
            });
        },
        show: function (key) {
            var currentIndex = images.findIndex(function (item) { return item.key === key; });
            updateState({
                visible: true,
                index: currentIndex,
            });
            if (onVisibleChange) {
                onVisibleChange(true, currentIndex, state);
            }
        },
    });
    var fn = useMethods({
        close: function () {
            updateState({
                visible: false,
            });
            if (onVisibleChange) {
                onVisibleChange(false, index, state);
            }
        },
        changeIndex: function (nextIndex) {
            updateState({
                index: nextIndex,
            });
            if (onIndexChange) {
                onIndexChange(nextIndex, state);
            }
        },
    });
    var value = useMemo(function () { return (__assign(__assign({}, state), methods)); }, [state, methods]);
    return (_jsxs(PhotoContext.Provider, __assign({ value: value }, { children: [children, _jsx(PhotoSlider, __assign({ images: images, visible: visible, index: index, onIndexChange: fn.changeIndex, onClose: fn.close }, restProps))] })));
}
